import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap, tap } from 'rxjs/operators';
import { TechnologyService } from 'src/app/shared/services/technology.service';
import { NotificationService } from '../../shared/services/notification.service';
import {
  TechnologiesLoad,
  TechnologiesLoadError,
  TechnologiesLoadSuccess,
  TECHNOLOGIES_LOAD,
  TECHNOLOGIES_LOAD_ERROR,
  TECHNOLOGIES_LOAD_SUCCESS,
} from '../actions/technologies.actions';

@Injectable()
export class TechnologyEffects {
  public TechnologiesLoad$ = createEffect(() =>
    this.actions$.pipe(
      ofType<TechnologiesLoad>(TECHNOLOGIES_LOAD),
      tap(() => (this.notificationService.loading = true)),
      mergeMap(() =>
        this.technologyService.getAllTechnologies().pipe(
          map(techs => {
            return new TechnologiesLoadSuccess(techs);
          }),
          catchError(() => of(new TechnologiesLoadError()))
        )
      )
    )
  );

  public technologiesLoadSucces$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<TechnologiesLoadSuccess>(TECHNOLOGIES_LOAD_SUCCESS),
        tap(() => (this.notificationService.loading = false))
      ),
    { dispatch: false }
  );

  public technologiesLoadError$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<TechnologiesLoadError>(TECHNOLOGIES_LOAD_ERROR),
        tap(() => (this.notificationService.loading = false)),
        tap(() => this.notificationService.openSnackBar('error', 'COMMON.TECHNOLOGIES_NOT_LOADED'))
      ),
    { dispatch: false }
  );

  constructor(
    private actions$: Actions,
    private notificationService: NotificationService,
    private technologyService: TechnologyService
  ) {}
}
